module.exports = __webpack_public_path__ + "static/stores-list-77e82fb45bcbb0c66817beffa13fbc97.png";